import { type IDropDownItem } from 'BreetHelpers';

const DropdownItemsFundingMethod = ({ item }: { item: IDropDownItem }) => (
	<span className='dropdown_content_item_options_item_name'>{item.value}</span>
);

export default DropdownItemsFundingMethod;
